import TabsItem from "./TabsItem";
import TabsList from "./TabsList";
import { StyledTabs } from "./StyledTabs";

type TabsProps = {
  tabHeaderList: { value: number; label: string }[];
  selectedTab: number;
  setSelectedTab: (a: number) => void;
};

const Tabs = ({ tabHeaderList, selectedTab, setSelectedTab }: TabsProps) => {
  return (
    <StyledTabs>
      <TabsList>
        {tabHeaderList.map(({ label, value }) => (
          <TabsItem
            key={value}
            value={selectedTab}
            className={selectedTab === value ? "active" : ""}
            onClick={() => setSelectedTab(value)}
            active={selectedTab === value}
          >
            {label}
          </TabsItem>
        ))}
      </TabsList>
    </StyledTabs>
  );
};

export default Tabs;
